import gql from 'graphql-tag';

export default gql`
    query GetAllYards {
        getAllYards {
            yardId
            yardName
            yardType
        }
    }
`;
